// extracted by mini-css-extract-plugin
module.exports = {"alertBox":"_3rQuG"};